import React from 'react';

import { Button, Group, Modal, ModalProps, Stack, Text, Title } from '@mantine/core';
import { LastCreditAlertContent } from 'utils/last-credit-alert';

interface LastCreditAlertModalProps extends Pick<ModalProps, 'onClose'> {
  alert: LastCreditAlertContent | null;
}

const LastCreditAlertModal = ({ alert, onClose }: LastCreditAlertModalProps): JSX.Element => {
  return (
    <Modal opened={!!alert} onClose={onClose} trapFocus centered size='lg'>
      <Title order={2} fw={600} ta='center'>
        {alert?.title}
      </Title>

      <Stack ta='center' mt='md'>
        <Text>{alert?.subtitle}</Text>

        <Text fw={600}>{alert?.description}</Text>
      </Stack>

      <Group position='center' mt='xl'>
        <Button mt='xl' onClick={onClose}>
          Got it
        </Button>
      </Group>
    </Modal>
  );
};

export default LastCreditAlertModal;
